<div class="clipContainer" [ngStyle]="{'width': ncWidth + 'px'}">
    <div class="clipBtnContainer">
        <div *ngIf="uploadMode" class="filebutton">
            <div>上传图片</div>
            <input type="file" id="file" class="fileInput" accept="image/*">
        </div>
        <div *ngIf="hasImage" class="confirmBtn" (click)="confirm()">确定</div>
    </div>
    <div class="clipImageCantainer">
        <img id="clipImage" src="" crossorigin="anonymous">
        <img id="clipPathImg" src="">
        <div id="clip">
            <div class="corner lt"></div>
            <div class="corner rt"></div>
            <div class="corner rb"></div>
            <div class="corner lb"></div>
        </div>
    </div>
    <div class="bottomInputContainer" *ngIf="hasImage && toolMode">
        <div class="inputRow">
            <div class="inputCol">
                <div class="rowLabel">宽：</div>
                <input class="nc-input-number sizeInput" type="number" [(ngModel)]="clipWidth" [min]="ncClipMinWidth"
                    [max]="clipImageWidth" step="1" (ngModelChange)="sizeInputChange()">
            </div>
            <div class="inputCol">
                <div class="rowLabel">高：</div>
                <input class="nc-input-number sizeInput" type="number" [(ngModel)]="clipHeight" [min]="ncClipMinHeight"
                    [max]="clipImageHeight" step="1" (ngModelChange)="sizeInputChange()">
            </div>
        </div>
        <div class="inputRow">
            <div class="inputCol">
                <div class="rowLabel">X：</div>
                <input class="nc-input-number sizeInput" type="number" [(ngModel)]="clipX" [min]="0"
                    [max]="clipImageWidth  - clipWidth" step="1" (ngModelChange)="sizeInputChange()">
            </div>
            <div class="inputCol">
                <div class="rowLabel">Y：</div>
                <input class="nc-input-number sizeInput" type="number" [(ngModel)]="clipY" [min]="0"
                    [max]="clipImageHeight - clipHeight" step="1" (ngModelChange)="sizeInputChange()">
            </div>
        </div>
    </div>
</div>